import { render, staticRenderFns } from "./ad-group-manager.vue?vue&type=template&id=4515b104&scoped=true&"
import script from "./ad-group-manager.vue?vue&type=script&lang=js&"
export * from "./ad-group-manager.vue?vue&type=script&lang=js&"
import style0 from "./ad-group-manager.vue?vue&type=style&index=0&id=4515b104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4515b104",
  null
  
)

export default component.exports